import { getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled from 'styled-components';
export const ContainerStyled = styled.div `
  ${({ sizeStyles }) => getStyles(sizeStyles?.container)};
  ${({ styles }) => getStyles(styles?.container)};
  background-color: ${({ containerBackgroundColor }) => containerBackgroundColor};
`;
//# sourceMappingURL=badgeIcon.styled.js.map